const resourceMap = {
    "video": {
        'title': 'Workshops',
        'singular': 'Workshop',
        'site_url': '/resources/{content_type}/{id}',
        'rating': true,
        'favourite': true,
    },
    "relax": {
        'title': 'Relaxation',
        'singular': 'Relaxation Exercise',
        'site_url': '/resources/{content_type}/{id}',
        'rating': true,
        'favourite': true,
    },
    "relaxationexercise": {
        'title': 'Relaxation',
        'singular': 'Relaxation Exercise',
        'site_url': '/resources/{content_type}/{id}',
        'rating': true,
        'favourite': true,
    },
    "article": {
        'title': 'Exercise',
        'singular': 'Exercise',
        'site_url': '/resources/{content_type}/{id}',
        'rating': true,
        'favourite': true,
    },
    "recipe": {
        'title': 'Recipies',
        'singular': 'Recipe',
        'site_url': '/resources/{content_type}/{id}',
        'rating': true,
        'favourite': true,
    },
    "newsletter": {
        'title': 'Blogs',
        'singular': 'Blog',
        'site_url': '/resources/{content_type}/{id}',
        'rating': false,
        'favourite': false,
    },
    'questionnaire': {
        'title': 'TBC',
        'singular': 'TBC',
        'site_url': '/resources/{content_type}/{id}',
        'rating': false,
        'favourite': false,
    },
    'self_assessment': {
        'title': 'TBC',
        'singular': 'TBC',
        'site_url': '/resources/{content_type}/{id}',
        'rating': false,
        'favourite': false,
    },
    'sentiment': {
        'title': 'Emotional Navigators',
        'singular': 'Emotional Navigator',
        'site_url': '/resources/{content_type}/{id}',
        'rating': false,
        'favourite': false,
    },
    'employer': {
        'title': 'Resource',
        'site_url': '/resources/{content_type}/{id}',
        'singular': 'Employer Resource',
        'rating': false,
        'favourite': false,
    }
}

export const resourceMapper = (resourceType) => {
    return resourceMap[resourceType]
}

export const resourceUrl = (resource, isEmployer = false) => {
    let mappedResource = resourceMap[resource.content_type]
    let site_url = mappedResource.site_url
    site_url = site_url.replace('{id}', resource.id).replace('{content_type}', resource.content_type)
    return isEmployer ? `/employer${site_url}` : site_url
}